export default __webpack_public_path__ + "media/images/wedding-2-fa5efe7a4afacac80f54245d835b8708.png";